module.exports = __webpack_public_path__ + "img/electronic_electric_enabled_selected.d12a44dd.svg";